module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "remind"
  }, [_c('el-dialog', {
    attrs: {
      "title": "跟进提醒",
      "visible": _vm.dialogVisible,
      "modal": _vm.modal
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible = $event
      }
    }
  }, [_c('el-form', {
    ref: "ruleForm",
    staticClass: "custom-form",
    attrs: {
      "model": _vm.form,
      "rules": _vm.rules,
      "label-width": "140px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "标题",
      "prop": "title"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.form.title),
      callback: function($$v) {
        _vm.$set(_vm.form, "title", $$v)
      },
      expression: "form.title"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.getName(_vm.name)
    }
  }, [_c('span', {
    staticClass: "text"
  }, [_vm._v(_vm._s(_vm.customer.title) + _vm._s(_vm.multCustomers))])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "执行人",
      "prop": "reminder"
    }
  }, [_c('div', [_c('el-checkbox', {
    on: {
      "change": _vm.manualTrigger
    },
    model: {
      value: (_vm.form.reminder.manager),
      callback: function($$v) {
        _vm.$set(_vm.form.reminder, "manager", $$v)
      },
      expression: "form.reminder.manager"
    }
  }, [_vm._v("负责人")]), _vm._v(" "), _c('el-checkbox', {
    on: {
      "change": _vm.manualTrigger
    },
    model: {
      value: (_vm.form.reminder.cooper),
      callback: function($$v) {
        _vm.$set(_vm.form.reminder, "cooper", $$v)
      },
      expression: "form.reminder.cooper"
    }
  }, [_vm._v("协同人")]), _vm._v(" "), _c('el-checkbox', {
    on: {
      "change": _vm.manualTrigger
    },
    model: {
      value: (_vm.isCustom),
      callback: function($$v) {
        _vm.isCustom = $$v
      },
      expression: "isCustom"
    }
  }, [_vm._v("自定义人员")])], 1), _vm._v(" "), (_vm.isCustom) ? _c('el-select', {
    attrs: {
      "multiple": "",
      "filterable": "",
      "remote": "",
      "placeholder": "请选择自定义人员",
      "remote-method": _vm.remoteMethod,
      "loading": _vm.loading
    },
    model: {
      value: (_vm.form.userIds),
      callback: function($$v) {
        _vm.$set(_vm.form, "userIds", $$v)
      },
      expression: "form.userIds"
    }
  }, _vm._l((_vm.userList), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.value,
        "value": item.userId
      }
    }, [_c('dl', {
      staticClass: "custom-option"
    }, [_c('dt', {
      staticClass: "title"
    }, [_vm._v(_vm._s(item.value))]), _vm._v(" "), _c('dd', {
      staticClass: "avatar"
    }, [_c('img', {
      attrs: {
        "src": item.avatar,
        "width": "32",
        "height": "32"
      }
    })]), _vm._v(" "), _c('dd', {
      staticClass: "department"
    }, _vm._l((item.department), function(d) {
      return _c('span', [_vm._v(_vm._s(d))])
    }))])])
  })) : _vm._e()], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "跟进时间",
      "prop": "followTime"
    }
  }, [_c('el-date-picker', {
    attrs: {
      "editable": false,
      "type": "datetime",
      "format": "yyyy-MM-dd HH:mm",
      "value-format": "yyyy-MM-dd HH:mm",
      "picker-options": _vm.disableBefore,
      "placeholder": "选择日期时间"
    },
    model: {
      value: (_vm.form.followTime),
      callback: function($$v) {
        _vm.$set(_vm.form, "followTime", $$v)
      },
      expression: "form.followTime"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "提醒",
      "prop": "notifyType"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.form.notifyType),
      callback: function($$v) {
        _vm.$set(_vm.form, "notifyType", $$v)
      },
      expression: "form.notifyType"
    }
  }, _vm._l((_vm.notifyType), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }))], 1), _vm._v(" "), (_vm.form.notifyType === 5) ? _c('el-form-item', {
    attrs: {
      "label": "提醒时间",
      "prop": "notifyTime"
    }
  }, [_c('el-date-picker', {
    attrs: {
      "editable": false,
      "type": "datetime",
      "format": "yyyy-MM-dd HH:mm",
      "value-format": "yyyy-MM-dd HH:mm",
      "picker-options": _vm.disableBefore,
      "placeholder": "选择日期时间"
    },
    model: {
      value: (_vm.form.notifyTime),
      callback: function($$v) {
        _vm.$set(_vm.form, "notifyTime", $$v)
      },
      expression: "form.notifyTime"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "重复提醒",
      "prop": "loopUnit"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.form.loopUnit),
      callback: function($$v) {
        _vm.$set(_vm.form, "loopUnit", $$v)
      },
      expression: "form.loopUnit"
    }
  }, _vm._l((_vm.loopUnit), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }))], 1), _vm._v(" "), (_vm.form.loopUnit) ? _c('el-form-item', {
    attrs: {
      "label": "循环次数"
    }
  }, [_c('el-input-number', {
    attrs: {
      "min": 1,
      "max": 30
    },
    model: {
      value: (_vm.form.loopNum),
      callback: function($$v) {
        _vm.$set(_vm.form, "loopNum", $$v)
      },
      expression: "form.loopNum"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "备注",
      "prop": "content"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea"
    },
    model: {
      value: (_vm.form.content),
      callback: function($$v) {
        _vm.$set(_vm.form, "content", $$v)
      },
      expression: "form.content"
    }
  })], 1), _vm._v(" "), (['purchase', 'supplier'].indexOf(_vm.moduleName) === -1) ? _c('el-form-item', {
    attrs: {
      "label": "加入访客"
    }
  }, [_c('el-checkbox', {
    model: {
      value: (_vm.communicatePlan),
      callback: function($$v) {
        _vm.communicatePlan = $$v
      },
      expression: "communicatePlan"
    }
  }, [_vm._v("将此次提醒加入访客计划")])], 1) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.handleSubmit
    }
  }, [_vm._v("推 送")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-af11ed6a","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modal/customer/remind.vue
// module id = 1326
// module chunks = 82